const PackPreviewActionsWrapper = ({
  children
}: {
  children: React.ReactNode;
}) => (
  <div className='w-full flex flex-row flex-wrap items-center justify-center ~gap-2/4 py-2'>
    {children}
  </div>
);

export default PackPreviewActionsWrapper;
